module.exports = __webpack_public_path__ + "static/media/AB_K16_3.74967d5f.jpg";